import { render, staticRenderFns } from "./CustomerCustomerMessageTemplate.vue?vue&type=template&id=c2bed570&scoped=true"
import script from "./CustomerCustomerMessageTemplate.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerMessageTemplate.vue?vue&type=style&index=0&id=c2bed570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bed570",
  null
  
)

export default component.exports